#@import Booking.Views.PickerCollection
#@import Booking.Views.TimeBubble
#@import Booking.Presenters.TimeBubbles
#@export Booking.Views.TimeBubbles

class Booking.Views.TimeBubbles extends Booking.Views.PickerCollection

  presenter: Booking.Presenters.TimeBubbles

  templateName: 'timebubbles'

  allTimesClass: 'anytime-bubble'

  childView: Booking.Views.TimeBubble

  events:
    'change .anytime-bubble input': 'allTimesClicked'

  constructor: ->
    Booking.Views.PickerCollection.apply this, arguments

    @on 'picker:date:selected', => @render()

  render: ->
    unless @model.getSelectedDate()
      @clearContainer()
      return this

    Booking.Views.PickerCollection::render.apply this, arguments

    if @model.isMultiWindow()
      template = @childView::template()

      @container().prepend(
        $("<li class='time-bubble #{@allTimesClass}'>").html(
          template.render(
            bhc: 'input:anytimeBubble'
            selected: false
            disabled: false
            time: @translate('.alltimes')
          )
        )
      )

      @toggleAllTimesBubble @getSelectedModelsByDate().length is @getModels().length

    this

  select: (model) ->
    return unless model

    if @model.isMultiWindow()
      model.toggle()

      if model.isSelected()
        @toggleAllTimesBubble @getSelectedModelsByDate().length is @getModels().length
      else
        @toggleAllTimesBubble(false)

    else
      @getSelectedModels().map((model) -> model.deselect())
      model.select()

    @trigger 'select', model

  allTimesBubble: ->
    @$el.find(".#{@allTimesClass}")

  toggleAllTimesBubble: (value) ->
    @allTimesBubble().find('label').toggleClass('selected', value)

  getModels: ->
    @collection.getTimesByDate @model.getSelectedDate()

  getSelectedModels: ->
    @collection.getSelectedTimes()

  getSelectedModelsByDate: ->
    @collection.getSelectedTimesByDate @model.getSelectedDate()

  # Get all models for that date and select/deselect them
  allTimesClicked: ->

    return false unless @model.isMultiWindow()

    allTimesBubbleSelected = @allTimesBubble().find('label').hasClass('selected')

    method = if allTimesBubbleSelected then 'deselect' else 'select'
    _.map @getModels(), (model) -> model[method]()

    @toggleAllTimesBubble(!allTimesBubbleSelected)

    @trigger 'select', null

    return true

